<div class="model-card">
  <div class="model-name">
    <h3>{{ model.name }}</h3>
    <div>
      <div class="d-inline-block">
        @switch (model.type) {
          @case (1) {
            <span
              ><mat-icon class="access-color-blue">bookmark</mat-icon> Demo
              access</span
            >
          }
          @case (2) {
            <span
              ><mat-icon class="access-color-green">bookmark</mat-icon> Live
              access</span
            >
          }
          @case (3) {
            <span
              ><mat-icon class="access-color-yellow">bookmark</mat-icon>
              Customized Model</span
            >
          }
          @default {
            <span><mat-icon>bookmark</mat-icon> Missing model type</span>
          }
        }
      </div>
      @if (superAdmin) {
        <div class="d-inline-block ms-2">| {{ model.access }}</div>
      }
    </div>
  </div>
  <div class="model-stats">
    @if (model.region && model.region.name) {
      <span><mat-icon>location_on</mat-icon> {{ model.region.name }}</span>
    }
    @if (model.universe && model.universe.name) {
      <span><mat-icon>public</mat-icon> {{ model.universe.name }}</span>
    }
    @if (model.companies) {
      <span
        ><mat-icon>business_center</mat-icon>
        {{ model.companies }} companies</span
      >
    }
    @if (model.rebalancing && model.rebalancing.name) {
      <span><mat-icon>calculate</mat-icon> {{ model.rebalancing.name }}</span>
    }
    @if (model.currency && model.currency.name) {
      <span><mat-icon>local_atm</mat-icon> {{ model.currency.name }}</span>
    }
  </div>
  <div class="model-action">
    <button
      type="button"
      mat-stroked-button
      class="rounded-pill border-primary"
      color="primary"
      [routerLink]="['model', model.id]"
    >
      Show Overview
    </button>
  </div>
</div>
